export default __webpack_public_path__ + "static/media/wash.c351879c.svg";